import { EPAPER_MENU_ARE_LOADING, EPAPER_MENU_HAVE_ERROR, EPAPER_MENU_FETCH_DATA_SUCCESS } from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function ePaperMenuReducer (state = initialState, action) {
    switch (action.type) {
        case EPAPER_MENU_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case EPAPER_MENU_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case EPAPER_MENU_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.ePaperMenu,
                loading:false,
            }

        default:
            return state;
    }
}